import authEndPoint from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

export default {
  update: ({ messageId, email, values, conversation_id }) => {
    const urlData = authEndPoint.updateMessage(messageId);
    const separator = window.location.search ? '&' : '?';
    const conversationParam = conversation_id
      ? `${separator}conversation_id=${conversation_id}`
      : '';
    return API.patch(`${urlData.url}${conversationParam}`, {
      contact: { email },
      message: { submitted_values: values },
    });
  },
};
